import React from "react";
import { motion } from "framer-motion";
import { Mail, MapPin, Phone, Clock } from "lucide-react";
import { staggerVariants, VIEWPORT_ONCE } from "../../lib/motion";

const cards = [
    {
        icon: Mail,
        label: "Email us",
        value: "support@xpomarkets.co",
        href: "mailto:support@xpomarkets.co",
    },
    {
        icon: Phone,
        label: "Call us",
        value: "+269 333 7800",
        href: "tel:+2693337800",
    },
    {
        icon: MapPin,
        label: "Registered address",
        value: "Boulevard de Coalancanthe, Mutsamudu, Anjouan, Comoros",
    },
    {
        icon: Clock,
        label: "Support hours",
        value: "Mon - Fri · 24 hours",
    },
];

const cardVariants = staggerVariants({ x: -20, duration: 0.5, step: 0.05 });

export default function ContactInfoCards() {
    return (
        <div className="lg:col-span-2 space-y-5">
            {cards.map((c, i) => (
                <motion.a
                    key={c.label}
                    href={c.href || "#"}
                    variants={cardVariants}
                    initial="hidden"
                    whileInView="visible"
                    custom={i}
                    viewport={VIEWPORT_ONCE}
                    className="flex items-start gap-4 xpo-glass p-5 cursor-default"
                    data-testid={`contact-info-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                    <span className="w-11 h-11 rounded-xl bg-[#A6E3DC]/10 border border-[#A6E3DC]/20 grid place-items-center flex-shrink-0">
                        <c.icon size={18} className="text-[#A6E3DC]" />
                    </span>
                    <div>
                        <p className="text-xs text-slate-500 uppercase tracking-wider">
                            {c.label}
                        </p>
                        <p className="text-white font-semibold mt-1">
                            {c.value}
                        </p>
                    </div>
                </motion.a>
            ))}
        </div>
    );
}
